export default __webpack_public_path__ + "static/media/Logo+one.0f5ee44f.png";